import styled, { css } from 'styled-components';

import Currency from 'components/currency';

export const EntryDescriptionRow = styled.p`
  font-size: 0.9375rem;
  width: 100%;
  margin: 0;
  line-height: 1.4;
`;

export const Item = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  flex-wrap: wrap;
  padding: 0 0 0.875rem 0;

  :nth-of-type(n + 2) {
    border-top: 1px solid ${Styles.color.grey.four};
    padding: 0.875rem 0;
  }

  :last-of-type {
    padding-bottom: 0;
  }

  h4 {
    font-family: ${Styles.fontFamily.base};
    text-transform: ${Styles.textTransform.headlines};
    margin: 0.5rem 0;
    padding-right: 2.5rem;
  }
`;

export const ItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: baseline;
`;

export const ItemName = styled.h4`
  order: -2;
  flex: 1;
  line-height: 1;
`;

export const ItemPrice = styled.div`
  order: 999;
  width: 100%;
  margin: 0;
`;

export const ItemQuantityBadge = styled.div<{ quantityText?: string }>`
  order: -1;
  padding: 0 0.7rem;
  font-size: 0.75rem;
  background-color: ${Styles.color.grey.four};
  border-radius: 9999rem;
`;

export const StyledCurrency = styled(Currency)<{ $zeroAmount: boolean }>`
  ${p =>
    p.$zeroAmount &&
    css`
      color: ${Styles.color.validated};
    `}
`;
